<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;">
      <v-form ref="form" id="needs-validation" v-model="valid" lazy-validation class="pt-3">
        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 class="text-xs-left my-text">
              <h1 class="register-form--header">Liczba pacjentów</h1>
              <div class="sparator-container pt-4">
                <div class="sparator-rectangle"></div>
              </div>
              <div>
                <span class="register-form--sections">witaj! {{ apiData.declarant.first_name }}</span>
              </div>
              <div>
                <span>Wpisz</span>
                <span class="register-form--sections">liczbę pacjentów</span>
                <span>którą przebadała Twoja placówka w czasie</span>
                <span class="register-form--sections">Światowego Tygodnia Jaskry.</span>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-bottom-padding">
          <v-layout row wrap>
            <v-flex xs12 md6 lg4 class="mb-3">
              <v-layout>
                <v-flex xs4 md12 class="text-xs-left">
                  <div class="register-container--download px-2">
                    <v-avatar
                      :size="60"
                      color="rgb(39, 82, 113)"
                    >
                      <img src="/static/images/human-icon.svg" alt="" style="height: 60%; border-radius: 0">
                    </v-avatar>
                    <div class="register-container--download-text">
                      <span class="register-container--sections">dane placówki</span>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Liczba pacjentów"
                solo
                v-model="institution.treatPatients"
                :rules="patientRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container>
          <v-layout row class="mt-3" @click="submit">
            <v-flex class="xs12 sm6">
              <my-button
                title="Zarejestruj"
                :text="isDisabled ? '<span>Sprawdzam</span>' : '<span>Wyślij</span>'"
                customClass="doctor rect-x1"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-dialog v-model="dialog1" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>Dziękujemy za rejestację. Udzielenie odpowiedzi.</h3>
            <h3 class="register-form--links">Jeśli nie widzisz naszej wiadomości, sprawdź folder "spam" lub "oferty".</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog1 = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
import DoctorHeader from '@/components/partials/DoctorHeader';
import MyButton from '@/components/partials/Button';

export default {
  data() {
    return {
      valid: true,
      isDisabled: false,
      dialog1: '',
      urlPath: process.env.APP_URL,
      apiData: [],
      institution: {
        id: '',
        email: '',
        treatPatients: '',
      },
      patientRules: [
        v => !!v || 'Pole jest wymagane',
        v => this.isNumber(v) || 'Zły format wpisz liczby',
      ],
    };
  },
  components: {
    DoctorHeader,
    MyButton,
  },
  beforeMount() {
    this.fetchInstitutions(this.$route.params.id);
  },
  mounted() {},
  methods: {
    isNumber(value) {
      if (value === null) {
        return true;
      }
      return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value);
    },
    reloadPage() {
      window.location.reload();
    },
    fetchInstitutions(id) {
      this.axios({
        method: 'GET',
        url: `${process.env.APP_URL}/api/get-institution/${id}`,
      })
      .then(result => {
        this.apiData = result.data
      });
    },
    showErrors(error) {
      this.$toasted.error(error, {
        theme: 'primary',
        position: 'bottom-right',
        duration: 5000,
      });
    },
    submit() {
      if (this.$refs.form.validate() && !this.isDisabled) {
        this.isDisabled = true;
        const data = {
          'institution':
          {
            'id': this.apiData.id,
            'treatPatients': this.institution.treatPatients,
          },
        };
        this.axios({
          method: 'POST',
          url: `${process.env.APP_URL}/api/store-patients`,
          data,
        })
        .then((response) => {
          this.isDisabled = false;
          this.$refs.form.reset();
          this.dialog1 = true;
          this.fetchParticipant(this.$route.params.id);
        });
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.c-green {
  color: #007F00;
}
.term-container--position {
  align-items: baseline !important;
}
.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}
.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}
.banner { background-color: transparent; }

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: 'Fira Sans', sans-serif;
  text-align: left;
  color: #aaa;
  display: block;
  vertical-align: middle;
 }
.banner img {
  float: left;
 }

.time-container {
  display: inline-flex;
  width: 100%;
}
.time-container--separator {
  width: 145px;
  padding-right: 5px;
}
.register-form--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}
.register-form--header {
  font-size: 26px;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  color: #a41611;
  text-transform: uppercase;
}
.register-form--links {
  color: #a41611;
  font-family: 'Fira Sans', sans-serif;
}
.register-form--sections {
  color: #275271;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.doctors-container--sections {
  color: #a41611;
}
.register-form--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.register-form--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: none;
  padding: 5px;
}
.register-form--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: '';
  position: fixed;
  opacity: 0.1;
  background-image: url('./../assets/images/register-bg.png');
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
}
.button-container--register {
  font-family: 'Fira Sans', sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.doctor-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 50px!important;
  padding-bottom: 50px!important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}

.register-container--download {
  text-decoration: none;
    display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.register-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}
.register-container--sections {
  color: #275271;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/PatientsNumber.vue